import { render, staticRenderFns } from "./PriceBreakdown.view.vue?vue&type=template&id=0b1bcd31&"
import script from "./PriceBreakdown.view.vue?vue&type=script&lang=js&"
export * from "./PriceBreakdown.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1bcd31')) {
      api.createRecord('0b1bcd31', component.options)
    } else {
      api.reload('0b1bcd31', component.options)
    }
    module.hot.accept("./PriceBreakdown.view.vue?vue&type=template&id=0b1bcd31&", function () {
      api.rerender('0b1bcd31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/PriceBreakdown.view.vue"
export default component.exports